import {
  INSCRIPTION_CREE_REQUETTE,
  INSCRIPTION_CREE_SUCCES,
  INSCRIPTION_CREE_ECHEC,
  INSCRIPTION_LISTE_ECHEC,
  INSCRIPTION_LISTE_SUCCES,
  INSCRIPTION_LISTE_REQUETTE,
  INSCRIPTION_CREE_RESET,
} from "../constantes/inscriptionConstantes";

export const inscriptionListeReducer = (
  state = { inscriptions: [] },
  action
) => {
  switch (action.type) {
    case INSCRIPTION_LISTE_SUCCES:
      return { inscriptions: action.payload };
    case INSCRIPTION_LISTE_ECHEC:
      return { erreur: action.payload };
    default:
      return state;
  }
};

export const inscriptionCreeReducer = (
  state = { inscription: {}, erreur: "" },
  action
) => {
  switch (action.type) {
    case INSCRIPTION_CREE_REQUETTE:
      return { loading: true };
    case INSCRIPTION_CREE_SUCCES:
      return { loading: false, inscription: action.payload };
    case INSCRIPTION_CREE_ECHEC:
      return { loading: false, erreur: action.payload };
    case INSCRIPTION_CREE_RESET:
      return { loading: false, inscription: {}, erreur: "" };

    default:
      return { ...state };
  }
};
